import axiosInstace from './../providers/Axios';

import { getImage } from '../config/paths';

export const callGetImage = async (sku) => {
  return axiosInstace({
    url: `${getImage}/${sku}`,
    method: 'get',
  });
};
